<template>
  <div
    class="p-g01-item-carousel"
    :class="[`p-g01-item-carousel--${carouselName}`]"
  >
    <div class="p-g01-item-carousel__button p-g01-item-carousel__button--prev">
      <div class="p-g01-item-carousel__button__icon__wrap">
        <IconBase
          class="p-g01-item-carousel__button__icon"
          view-box="0 0 24 24"
          width="24"
          height="24"
        >
          <IconArrowLeft />
        </IconBase>
      </div>
    </div>
    <div class="p-g01-item-carousel__button p-g01-item-carousel__button--next">
      <div class="p-g01-item-carousel__button__icon__wrap">
        <IconBase
          class="p-g01-item-carousel__button__icon"
          view-box="0 0 24 24"
          width="24"
          height="24"
        >
          <IconArrowRight />
        </IconBase>
      </div>
    </div>
    <Swiper class="swiper" :options="swiperOption">
      <SwiperSlide v-for="(item, key) in items" :key="key">
        <G01IconRanking
          :num="key + 1"
          class="p-g01-item-carousel__ranking_icon"
        />
        <ItemListPanel
          :id="item.premium.id"
          :img-path="getImagePath(item.premium)"
          :name="item.premium.name"
          :point="item.point_required"
          :discount-rate="0"
          :is-favorite="item.is_new"
          :color="getColor(item)"
          :status="status(item)"
          :stock="item.quantity"
          :stock-control="item.is_quantity_control"
        />
      </SwiperSlide>
    </Swiper>
  </div>
</template>

<script lang="ts">
import { Swiper, SwiperSlide } from 'swiper/vue';
import ItemListPanel from "@/general/components/molecules/ItemListPanel.vue";
import IconBase from "@/common/components/atoms/IconBase.vue";
import IconArrowLeft from "@/common/components/icons/IconArrowLeft.vue";
import IconArrowRight from "@/common/components/icons/IconArrowRight.vue";
import G01IconRanking from "@/general/components/pages/parts/Ranking/G01IconRanking.vue";
import { Options, Vue } from 'vue-class-component';
import "swiper/swiper-bundle.css";
import commons from "@/common/store/modules/commons";

@Options({
  props: {
    items: { type: Array, required: false },
    carouselName: { type: String, required: false, default: "default" }
  },
  components: {
    Swiper,
    SwiperSlide,
    ItemListPanel,
    IconBase,
    IconArrowLeft,
    IconArrowRight,
    G01IconRanking
  }
})
export default class G01ItemCarousel extends Vue {
  items!: any;
  carouselName!: string;

  swiperOption = {
    slidesPerView: 5,
    spaceBetween: 16,
    slidesPerGroup: 5,
    // loop: true, // NOTICE: If set to true, click event will not be cloned.
    // loopFillGroupWithBlank: true,
    watchOverflow: true,
    navigation: {
      nextEl: `.p-g01-item-carousel--${this.carouselName} .p-g01-item-carousel__button--next`,
      prevEl: `.p-g01-item-carousel--${this.carouselName} .p-g01-item-carousel__button--prev`
    }
  };

  getImagePath(premium: any) {
    let imgUrl = "";
    premium?.premiumimage_set?.forEach((img: any) => {
      if (img?.is_primary == true) {
        imgUrl = img?.image_url;
      }
    });
    return imgUrl;
  }

  status(item: any) {
    if (item.is_quantity_control && item.quantity == 0) {
      //out of stock
      return "在庫なし";
    } else if (item.premium.is_new === true) {
      //New
      return "New";
    } else if (item.premium.is_featured === true) {
      //Recommended
      return "おすすめ";
    } else {
      //show nothing
      return false;
    }
  }

  getColor(item: any) {
    return item.is_quantity_control && item.quantity == 0
      ? "#333"
      : commons.colorCode;
  }
}
</script>

<style lang="scss" scoped>
// @import url("~swiper/css/swiper.css");

.p-g01-item-carousel {
  position: relative;
  padding: 0 rem(56);

  &__button {
    position: absolute;
    top: 0;
    bottom: rem(24);
    z-index: 1;
    margin: auto;
    width: rem(48);
    height: rem(48);
    padding: rem(10);
    cursor: pointer;

    &.swiper-button-disabled {
      opacity: 0.3;
      cursor: default;
    }

    &__icon {
      color: $common-gray700;

      &__wrap {
        width: rem(28);
        height: rem(28);
        padding: rem(2);
        border-radius: 50%;
        background: #ffffff;
        box-shadow: 0 0 px(10) rgba(0, 0, 0, 0.25);
      }
    }

    &--prev {
      left: 0;
    }
    &--next {
      right: 0;
    }
  }

  &__ranking_icon {
    margin: 0 0 rem(12) rem(16);
    display: flex;
    align-items: center;
  }
}
</style>
